import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Box } from '../../../../components/atoms/Box';
import { TextField } from '../../../../components/atoms/TextField';
import { Typography } from '../../../../components/atoms/Typography';

import { COLORS } from '../../../../configs/colors';

export const StyledTypography = styled(Typography)`
  margin-bottom:10px;
`;

export const StyledWrapperGrid = styled(Grid)`
  padding: 10px;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
  margin-top: 10px;
`;

export const InputGroupWrapperBox = styled(Box)`
  width: 98%;
  margin-left: 10px;
`;

export const StyledTextField = styled(TextField)`
  margin-bottom: 15px;
`;

export const MultiSelectFieldWrapper = styled(Grid)`
  margin-bottom: 20px;
`;